import React from "react";

export function Card({ children, className = "", ...rest }) {
  return (
    <div className={`surface rounded-2xl ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function Badge({ children, tone = "silver", className = "" }) {
  const tones = {
    silver: "border-white/12 text-neutral-300",
    verified: "border-emerald-400/30 text-emerald-300/90 bg-emerald-400/5",
    pending: "border-amber-400/30 text-amber-300/90 bg-amber-400/5",
    rejected: "border-rose-400/30 text-rose-300/90 bg-rose-400/5",
    demo: "border-white/12 text-neutral-400 bg-white/[0.02]",
  };
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest ${tones[tone] || tones.silver} ${className}`}>
      {children}
    </span>
  );
}

export function EmptyState({ icon: Icon, title, desc }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-white/10 py-16 text-center">
      {Icon && <Icon size={26} className="mb-4 text-neutral-600" />}
      <p className="font-head text-sm font-bold uppercase tracking-tight text-neutral-300">{title}</p>
      {desc && <p className="mt-1.5 max-w-xs text-sm text-neutral-500">{desc}</p>}
    </div>
  );
}

export function Skeleton({ className = "" }) {
  return <div className={`skeleton rounded-lg ${className}`} />;
}
